module.exports = __webpack_public_path__ + "img/4.179eb55d.jpg";